// components/accordion/accordion.tsx
export const sdfAccordionSlotNames = ['default'] as const;
export type SdfAccordionSlots = { [K in (typeof sdfAccordionSlotNames)[number]]: () => unknown };

// components/action-area/action-area.tsx
export const sdfActionAreaSlotNames = ['default'] as const;
export type SdfActionAreaSlots = { [K in (typeof sdfActionAreaSlotNames)[number]]: () => unknown };

// components/action-menu/action-menu.tsx
export const sdfActionMenuSlotNames = ['default'] as const;
export type SdfActionMenuSlots = { [K in (typeof sdfActionMenuSlotNames)[number]]: () => unknown };

// components/alert-banner/alert-banner.tsx
export const sdfAlertBannerSlotNames = ['default', 'icon', 'title', 'action'] as const;
export type SdfAlertBannerSlots = { [K in (typeof sdfAlertBannerSlotNames)[number]]: () => unknown };

// components/alert-inline/alert-inline.tsx
export const sdfAlertInlineSlotNames = ['default', 'icon'] as const;
export type SdfAlertInlineSlots = { [K in (typeof sdfAlertInlineSlotNames)[number]]: () => unknown };

// components/alert/alert.tsx
export const sdfAlertSlotNames = ['default', 'icon', 'title', 'action'] as const;
export type SdfAlertSlots = { [K in (typeof sdfAlertSlotNames)[number]]: () => unknown };

// components/badge/badge.tsx
export const sdfBadgeSlotNames = ['default', 'graphic'] as const;
export type SdfBadgeSlots = { [K in (typeof sdfBadgeSlotNames)[number]]: () => unknown };

// components/box/box.tsx
export const sdfBoxSlotNames = ['default'] as const;
export type SdfBoxSlots = { [K in (typeof sdfBoxSlotNames)[number]]: () => unknown };

// components/box-stack/box-stack.tsx
export const sdfBoxStackSlotNames = ['default'] as const;
export type SdfBoxStackSlots = { [K in (typeof sdfBoxStackSlotNames)[number]]: () => unknown };

// components/button-group/button-group.tsx
export const sdfButtonGroupSlotNames = ['default'] as const;
export type SdfButtonGroupSlots = { [K in (typeof sdfButtonGroupSlotNames)[number]]: () => unknown };

// components/button/button.tsx
export const sdfButtonSlotNames = ['default'] as const;
export type SdfButtonSlots = { [K in (typeof sdfButtonSlotNames)[number]]: () => unknown };

// components/card-footer/card-footer.tsx
export const sdfCardFooterSlotNames = ['default', 'supplemental-actions'] as const;
export type SdfCardFooterSlots = { [K in (typeof sdfCardFooterSlotNames)[number]]: () => unknown };

// components/card-header-advanced/card-header-advanced.tsx
export const sdfCardHeaderAdvancedSlotNames = ['title', 'actions'] as const;
export type SdfCardHeaderAdvancedSlots = { [K in (typeof sdfCardHeaderAdvancedSlotNames)[number]]: () => unknown };

// components/card-header-collapsible/card-header-collapsible.tsx
export const sdfCardHeaderCollapsibleSlotNames = ['default'] as const;
export type SdfCardHeaderCollapsibleSlots = {
  [K in (typeof sdfCardHeaderCollapsibleSlotNames)[number]]: () => unknown;
};

// components/card-header/card-header.tsx
export const sdfCardHeaderSlotNames = ['default'] as const;
export type SdfCardHeaderSlots = { [K in (typeof sdfCardHeaderSlotNames)[number]]: () => unknown };

// components/card/card.tsx
export const sdfCardSlotNames = ['default'] as const;
export type SdfCardSlots = { [K in (typeof sdfCardSlotNames)[number]]: () => unknown };

// components/carousel-item/carousel-item.tsx
export const sdfCarouselItemSlotNames = ['default'] as const;
export type SdfCarouselItemSlots = { [K in (typeof sdfCarouselItemSlotNames)[number]]: () => unknown };

// components/chart/chart.tsx
export const sdfChartSlotNames = ['description'] as const;
export type SdfChartSlots = { [K in (typeof sdfChartSlotNames)[number]]: () => unknown };

// components/checkbox-group/checkbox-group.tsx
export const sdfCheckboxGroupSlotNames = ['custom-label', 'default', 'alert', 'help', 'help-popover'] as const;
export type SdfCheckboxGroupSlots = { [K in (typeof sdfCheckboxGroupSlotNames)[number]]: () => unknown };

// components/checkbox/checkbox.tsx
export const sdfCheckboxSlotNames = ['default', 'description'] as const;
export type SdfCheckboxSlots = { [K in (typeof sdfCheckboxSlotNames)[number]]: () => unknown };

// components/currency-input/currency-input.tsx
export const sdfCurrencyInputSlotNames = ['custom-label', 'alert', 'help', 'before', 'after', 'help-popover'] as const;
export type SdfCurrencyInputSlots = { [K in (typeof sdfCurrencyInputSlotNames)[number]]: () => unknown };

// components/dashboard-cell/dashboard-cell.tsx
export const sdfDashboardCellSlotNames = ['default'] as const;
export type SdfDashboardCellSlots = { [K in (typeof sdfDashboardCellSlotNames)[number]]: () => unknown };

// components/dashboard/dashboard.tsx
export const sdfDashboardSlotNames = ['default'] as const;
export type SdfDashboardSlots = { [K in (typeof sdfDashboardSlotNames)[number]]: () => unknown };

// components/data-ring/data-ring.tsx
export const sdfDataRingSlotNames = ['status'] as const;
export type SdfDataRingSlots = { [K in (typeof sdfDataRingSlotNames)[number]]: () => unknown };

// components/date-picker/date-picker.tsx
export const sdfDatePickerSlotNames = ['alert', 'custom-label', 'help', 'help-popover'] as const;
export type SdfDatePickerSlots = { [K in (typeof sdfDatePickerSlotNames)[number]]: () => unknown };

// components/date-picker-v2/date-picker-v2.tsx
export const sdfDatePickerV2SlotNames = ['custom-label', 'alert', 'help', 'help-popover'] as const;
export type SdfDatePickerV2Slots = { [K in (typeof sdfDatePickerV2SlotNames)[number]]: () => unknown };

// components/expandable-box/expandable-box.tsx
export const sdfExpandableBoxSlotNames = ['default', 'header'] as const;
export type SdfExpandableBoxSlots = { [K in (typeof sdfExpandableBoxSlotNames)[number]]: () => unknown };

// components/file-item/file-item.tsx
export const sdfFileItemSlotNames = ['notification'] as const;
export type SdfFileItemSlots = { [K in (typeof sdfFileItemSlotNames)[number]]: () => unknown };

// components/flag-layout/flag-layout.tsx
export const sdfFlagLayoutSlotNames = ['default', 'graphic', 'headline', 'supporting-content', 'action'] as const;
export type SdfFlagLayoutSlots = { [K in (typeof sdfFlagLayoutSlotNames)[number]]: () => unknown };

// components/floating-pane/floating-pane.tsx
export const sdfFloatingPaneSlotNames = [
  'default',
  'header-label',
  'footer-content',
  'extra-detail',
  'supporting-content',
] as const;
export type SdfFloatingPaneSlots = { [K in (typeof sdfFloatingPaneSlotNames)[number]]: () => unknown };

// components/focus-pane/focus-pane.tsx
export const sdfFocusPaneSlotNames = ['default', 'icon', 'title', 'custom-buttons'] as const;
export type SdfFocusPaneSlots = { [K in (typeof sdfFocusPaneSlotNames)[number]]: () => unknown };

// components/form-control-layout/form-control-layout.tsx
export const sdfFormControlLayoutSlotNames = ['default', 'alert', 'help', 'help-popover'] as const;
export type SdfFormControlLayoutSlots = { [K in (typeof sdfFormControlLayoutSlotNames)[number]]: () => unknown };

// components/grid/grid.tsx
export const sdfGridSlotNames = ['default'] as const;
export type SdfGridSlots = { [K in (typeof sdfGridSlotNames)[number]]: () => unknown };

// components/help-text/help-text.tsx
export const sdfHelpTextSlotNames = ['default'] as const;
export type SdfHelpTextSlots = { [K in (typeof sdfHelpTextSlotNames)[number]]: () => unknown };

// components/layouts/home-page-layout/home-page-layout.tsx
export const sdfHomePageLayoutSlotNames = ['search', 'col-1', 'user-card', 'col-2'] as const;
export type SdfHomePageLayoutSlots = { [K in (typeof sdfHomePageLayoutSlotNames)[number]]: () => unknown };

// components/icon-button/icon-button.tsx
export const sdfIconButtonSlotNames = ['default'] as const;
export type SdfIconButtonSlots = { [K in (typeof sdfIconButtonSlotNames)[number]]: () => unknown };

// components/icon-stack/icon-stack.tsx
export const sdfIconStackSlotNames = ['foreground', 'background'] as const;
export type SdfIconStackSlots = { [K in (typeof sdfIconStackSlotNames)[number]]: () => unknown };

// components/input/input.tsx
export const sdfInputSlotNames = ['custom-label', 'alert', 'help', 'before', 'after', 'help-popover'] as const;
export type SdfInputSlots = { [K in (typeof sdfInputSlotNames)[number]]: () => unknown };

// components/layouts/justify-edge/justify-edge.tsx
export const sdfLayoutJustifyEdgeSlotNames = ['default'] as const;
export type SdfLayoutJustifyEdgeSlots = { [K in (typeof sdfLayoutJustifyEdgeSlotNames)[number]]: () => unknown };

// components/layouts/layout-three-col/layout-three-col.tsx
export const sdfLayoutThreeColSlotNames = ['col-1', 'col-2', 'col-3'] as const;
export type SdfLayoutThreeColSlots = { [K in (typeof sdfLayoutThreeColSlotNames)[number]]: () => unknown };

// components/layouts/layout-two-col/layout-two-col.tsx
export const sdfLayoutTwoColSlotNames = ['col-1', 'col-2'] as const;
export type SdfLayoutTwoColSlots = { [K in (typeof sdfLayoutTwoColSlotNames)[number]]: () => unknown };

// components/link/link.tsx
export const sdfLinkSlotNames = ['default'] as const;
export type SdfLinkSlots = { [K in (typeof sdfLinkSlotNames)[number]]: () => unknown };

// components/local-left-nav-item/local-left-nav-item.tsx
export const sdfLocalLeftNavItemSlotNames = ['default'] as const;
export type SdfLocalLeftNavItemSlots = { [K in (typeof sdfLocalLeftNavItemSlotNames)[number]]: () => unknown };

// components/local-left-nav-section/local-left-nav-section.tsx
export const sdfLocalLeftNavSectionSlotNames = ['default', 'heading'] as const;
export type SdfLocalLeftNavSectionSlots = { [K in (typeof sdfLocalLeftNavSectionSlotNames)[number]]: () => unknown };

// components/local-left-nav/local-left-nav.tsx
export const sdfLocalLeftNavSlotNames = ['default'] as const;
export type SdfLocalLeftNavSlots = { [K in (typeof sdfLocalLeftNavSlotNames)[number]]: () => unknown };

// components/menu-item/menu-item.tsx
export const sdfMenuItemSlotNames = ['default', 'before', 'after'] as const;
export type SdfMenuItemSlots = { [K in (typeof sdfMenuItemSlotNames)[number]]: () => unknown };

// components/menu-title/menu-title.tsx
export const sdfMenuTitleSlotNames = ['default'] as const;
export type SdfMenuTitleSlots = { [K in (typeof sdfMenuTitleSlotNames)[number]]: () => unknown };

// components/menu/menu.tsx
export const sdfMenuSlotNames = ['default'] as const;
export type SdfMenuSlots = { [K in (typeof sdfMenuSlotNames)[number]]: () => unknown };

// components/mini-card/mini-card.tsx
export const sdfMiniCardSlotNames = ['graphic', 'title', 'subtitle', 'action'] as const;
export type SdfMiniCardSlots = { [K in (typeof sdfMiniCardSlotNames)[number]]: () => unknown };

// components/multi-select/multi-select.tsx
export const sdfMultiSelectSlotNames = ['custom-label', 'default', 'alert', 'help', 'help-popover'] as const;
export type SdfMultiSelectSlots = { [K in (typeof sdfMultiSelectSlotNames)[number]]: () => unknown };

// components/layouts/page-header-layout/page-header-layout.tsx
export const sdfPageHeaderLayoutSlotNames = [
  'default',
  'breadcrumbs',
  'page-type',
  'title-additions',
  'supporting-content',
  'title-content',
  'primary-actions',
] as const;
export type SdfPageHeaderLayoutSlots = { [K in (typeof sdfPageHeaderLayoutSlotNames)[number]]: () => unknown };

// components/page-layout/page-layout.tsx
export const sdfPageLayoutSlotNames = [
  'default',
  'page-title',
  'breadcrumbs',
  'page-type',
  'title-additions',
  'supporting-content',
  'title-content',
  'primary-actions',
] as const;
export type SdfPageLayoutSlots = { [K in (typeof sdfPageLayoutSlotNames)[number]]: () => unknown };

// components/phone-number-input/phone-number-input.tsx
export const sdfPhoneNumberInputSlotNames = ['custom-label', 'alert', 'help', 'help-popover'] as const;
export type SdfPhoneNumberInputSlots = { [K in (typeof sdfPhoneNumberInputSlotNames)[number]]: () => unknown };

// components/promo-box/promo-box.tsx
export const sdfPromoBoxSlotNames = ['cta'] as const;
export type SdfPromoBoxSlots = { [K in (typeof sdfPromoBoxSlotNames)[number]]: () => unknown };

// components/quick-stat/quick-stat.tsx
export const sdfQuickStatSlotNames = ['default', 'label'] as const;
export type SdfQuickStatSlots = { [K in (typeof sdfQuickStatSlotNames)[number]]: () => unknown };

// components/radio-button/radio-button.tsx
export const sdfRadioButtonSlotNames = ['default', 'description'] as const;
export type SdfRadioButtonSlots = { [K in (typeof sdfRadioButtonSlotNames)[number]]: () => unknown };

// components/radio-group/radio-group.tsx
export const sdfRadioGroupSlotNames = ['custom-label', 'default', 'alert', 'help', 'help-popover'] as const;
export type SdfRadioGroupSlots = { [K in (typeof sdfRadioGroupSlotNames)[number]]: () => unknown };

// components/readonly-field/readonly-field.tsx
export const sdfReadonlyFieldSlotNames = ['default', 'custom-label', 'alert', 'help', 'help-popover'] as const;
export type SdfReadonlyFieldSlots = { [K in (typeof sdfReadonlyFieldSlotNames)[number]]: () => unknown };

// components/search/search.tsx
export const sdfSearchSlotNames = ['alert', 'help', 'empty', 'help-popover'] as const;
export type SdfSearchSlots = { [K in (typeof sdfSearchSlotNames)[number]]: () => unknown };

// components/select-group/select-group.tsx
export const sdfSelectGroupSlotNames = ['default'] as const;
export type SdfSelectGroupSlots = { [K in (typeof sdfSelectGroupSlotNames)[number]]: () => unknown };

// components/select-item-list/select-item-list.tsx
export const sdfSelectItemListSlotNames = ['default'] as const;
export type SdfSelectItemListSlots = { [K in (typeof sdfSelectItemListSlotNames)[number]]: () => unknown };

// components/select-item/select-item.tsx
export const sdfSelectItemSlotNames = ['default'] as const;
export type SdfSelectItemSlots = { [K in (typeof sdfSelectItemSlotNames)[number]]: () => unknown };

// components/select-list/select-list.tsx
export const sdfSelectListSlotNames = ['default'] as const;
export type SdfSelectListSlots = { [K in (typeof sdfSelectListSlotNames)[number]]: () => unknown };

// components/select-option/select-option.tsx
export const sdfSelectOptionSlotNames = ['default'] as const;
export type SdfSelectOptionSlots = { [K in (typeof sdfSelectOptionSlotNames)[number]]: () => unknown };

// components/select-simple/select-simple.tsx
export const sdfSelectSimpleSlotNames = ['custom-label', 'default', 'alert', 'help', 'help-popover'] as const;
export type SdfSelectSimpleSlots = { [K in (typeof sdfSelectSimpleSlotNames)[number]]: () => unknown };

// components/super-title/super-title.tsx
export const sdfSuperTitleSlotNames = ['default', 'links'] as const;
export type SdfSuperTitleSlots = { [K in (typeof sdfSuperTitleSlotNames)[number]]: () => unknown };

// components/switch/switch.tsx
export const sdfSwitchSlotNames = ['default'] as const;
export type SdfSwitchSlots = { [K in (typeof sdfSwitchSlotNames)[number]]: () => unknown };

// components/tab-group/tab-group.tsx
export const sdfTabGroupSlotNames = ['default'] as const;
export type SdfTabGroupSlots = { [K in (typeof sdfTabGroupSlotNames)[number]]: () => unknown };

// components/table/table.tsx
export const sdfTableSlotNames = ['empty'] as const;
export type SdfTableSlots = { [K in (typeof sdfTableSlotNames)[number]]: () => unknown };

// components/tab/tab.tsx
export const sdfTabSlotNames = ['default', 'after'] as const;
export type SdfTabSlots = { [K in (typeof sdfTabSlotNames)[number]]: () => unknown };

// components/tag/tag.tsx
export const sdfTagSlotNames = ['category', 'value'] as const;
export type SdfTagSlots = { [K in (typeof sdfTagSlotNames)[number]]: () => unknown };

// components/textarea/textarea.tsx
export const sdfTextareaSlotNames = ['custom-label', 'alert', 'help', 'help-popover'] as const;
export type SdfTextareaSlots = { [K in (typeof sdfTextareaSlotNames)[number]]: () => unknown };

// components/time-picker/time-picker.tsx
export const sdfTimePickerSlotNames = ['default', 'alert', 'help', 'help-popover'] as const;
export type SdfTimePickerSlots = { [K in (typeof sdfTimePickerSlotNames)[number]]: () => unknown };

// components/time-picker-v2/time-picker-v2.tsx
export const sdfTimePickerV2SlotNames = ['custom-label', 'alert', 'help', 'help-popover'] as const;
export type SdfTimePickerV2Slots = { [K in (typeof sdfTimePickerV2SlotNames)[number]]: () => unknown };

// components/time-spinner/time-spinner.tsx
export const sdfTimeSpinnerSlotNames = ['custom-label', 'alert', 'help'] as const;
export type SdfTimeSpinnerSlots = { [K in (typeof sdfTimeSpinnerSlotNames)[number]]: () => unknown };

// components/tooltip/tooltip.tsx
export const sdfTooltipSlotNames = ['default', 'tooltip-target'] as const;
export type SdfTooltipSlots = { [K in (typeof sdfTooltipSlotNames)[number]]: () => unknown };

// components/wizard-layout/wizard-layout.tsx
export const sdfWizardLayoutSlotNames = ['step-title', 'wizard-steps', 'page-content', 'buttons'] as const;
export type SdfWizardLayoutSlots = { [K in (typeof sdfWizardLayoutSlotNames)[number]]: () => unknown };

// components/wizard-steps-vertical/wizard-steps-vertical.tsx
export const sdfWizardStepsVerticalSlotNames = ['default', 'slot-title'] as const;
export type SdfWizardStepsVerticalSlots = { [K in (typeof sdfWizardStepsVerticalSlotNames)[number]]: () => unknown };
